// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6723) return "static/chunks/worker-chunks-9f07ff7b2cc40238.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "9c6e869a5000b528" + ".js";
};